import React from 'react';
import { Bell } from 'lucide-react';

const NotificationBell = ({ count = 0, onClick }) => (
  <button
    onClick={onClick}
    className="relative p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
  >
    <Bell className="w-6 h-6" />
    {count > 0 && (
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center animate-pulse">
        {count > 9 ? '9+' : count}
      </span>
    )}
  </button>
);

export default NotificationBell;
